import React, { useState, useEffect } from 'react';
import { days } from '../../../../../common/constants';
import SelectOption from '../../../../../common/SelectOption';
import { Form } from 'antd';
import useInputValidator from '../../../../../../hooks/useInputValidator';
import TimeRangePicker from '../../../../../common/TimePickerWithHourly/TimeRangePicker';
import { dailyPricingOptionValidation } from '../../../../../../helper/spaceFormValidation';
import { useSelector } from 'react-redux';
// import TimeRangePicker from '../../../../../common/TimePickerWithHourly/TimeRangePicker';

const DailyPricingOption = ({ paymentOptionIndex, paymentOptionId, form, currency, isEdit}) => {
  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!'
    }
  ];
  const formFields = isEdit ? form.getFieldValue() : null;
  const [timePickers, setTimePickers] = useState([{ beginTime: '3:00 am', endTime: '5:00 pm' }]);
  const [selectedDays, setSelectedDays] = useState([]);
  const deselectItems = item => {
    setSelectedDays(selectedDays.filter(i => i !== item));
  };
  const onSelectItems = days => {
    handleChange(days, [{ beginTime: '3:00 am', endTime: '5:00 pm' }]);
    setSelectedDays([...selectedDays, days]);
  };
  const { value, handleChange } = useInputValidator({});
  const days = useSelector((state)=>state.space?.pricingOptionsArray?.data?.filter(days=> days.chargingType==paymentOptionId)[0]?.pricingOptions || []);
  const [dateSelectionOptions, setDateSelectionOptions] = useState(days);
  const {pricingOptionsArray} = useSelector((state)=> state.space || []);

  useEffect(() => {
    setDateSelectionOptions(dailyPricingOptionValidation(days, selectedDays));
  }, [selectedDays]);

  useEffect(() => {
    if(isEdit && pricingOptionsArray?.fetching){
      const pricingOptions = formFields?.chargings?.[paymentOptionIndex]?.pricingOptions;
      pricingOptions && Object.entries(pricingOptions).forEach(
          ([key, data]) =>  {
            value[key] = []
            data.forEach(val => {
              value.pricePerHour = val.pricePerHour;
              value[key].push({ startTime: val.startTime, endTime: val.endTime });
            })
          }
      );
      formFields?.meetOrTrain?.dailyPricingOption?.days && setSelectedDays(formFields?.meetOrTrain?.dailyPricingOption?.days);
    }
    return () => {
      setSelectedDays([]);
      form.setFieldsValue({meetOrTrain: {dailyPricingOption: { days: []}}});
    }
  },[formFields?.id]);

  useEffect(()=> {
    let chargings =  form.getFieldValue('chargings');
    let chargingType =  form.getFieldValue(['chargings', paymentOptionIndex, 'chargingType', 'id']);
    if(!chargingType){
      if(!chargings) chargings = [];
      chargings = [...chargings ,{
        chargingType: { 
          id : paymentOptionId
        }
      }];
    form.setFieldsValue({
      chargings
    })  
    }
  }, [])

  return (
    <>
      <Form.Item name={['chargings', paymentOptionIndex, 'chargingType', 'id']}>
      </Form.Item>
      <h3>Daily Price</h3>
      <SelectOption
        isMultiple={true}
        name={['meetOrTrain', 'dailyPricingOption', 'days']}
        placeholder={'Days'}
        rules={rules}
        label={'Days'}
        values={days}
        handleOnSelect={onSelectItems}
        handleOnDeselect={deselectItems}
      />
      {selectedDays.map((day, index) => (
        value[day] && value[day].length > 0 ? value?.[day].map((picker, index) => (
        <>
          <Form.Item label={day} name={['chargings', paymentOptionIndex, 'pricingOptions' , day, index]}>
            <TimeRangePicker
              key={index}
              pickers={value[day]}
              setTimePicker={handleChange}
              index={index}
              day={day}
              isEdit={isEdit}
              daily={true}
            />
          </Form.Item>
        </>
      )) : null
      ))}
    </>
  );
};

export default DailyPricingOption;
